<template>
  <div class="video-with-thumbnail">
    <div class="thumb-pic-overlay" v-if="!videoPlaying && video && showPlayIcon">
      <div class="thumb-pic-play-icon" @click="playVideoInThumbnail(id, true)"></div>
    </div>
    <div v-show="isVidProcessing" class="loading-con" id="loading-node"></div>

    <div
      v-if="video"
      :class="{
        'thumb-video-box': hidePosterOnLargeScreens,
        'thumb-image-box': !hidePosterOnLargeScreens,
      }"
    >
      <!-- :class="{ transparent: !this.videoPlaying && posterImage && !hidePosterOnLargeScreens }" -->
      <video
        :src="`${video}`"
        :poster="imageUrl"
        :ref="id"
        :style="displayAsIs ? { objectFit: 'contain' } : {}"
        :preload="preload"
        playsinline
        @pause="videoPlaying = false"
        @contextmenu="
          e => {
            e.preventDefault()
          }
        "
        disablePictureInPicture
        :controlslist="!showDownload ? 'nodownload' : ''"
      />
    </div>
    <!-- disablePictureInPicture -->
    <div
      v-show="posterImage && !videoPlaying"
      :class="{
        'thumb-image-box': true,
        'hide-on-lg': hidePosterOnLargeScreens,
        hiddenTransparent: videoPlaying,
      }"
      :style="{ 'background-image': 'url(' + posterImage + ')' }"
    ></div>
  </div>
</template>

<script>
import config from '@/config'
import { Loading } from 'element-ui'

export default {
  name: 'v-thumbnail-video',
  props: {
    displayAsIs: {
      type: Boolean,
      default: false,
    },
    showDownload: {
      type: Boolean,
      default: false,
    },
    isVidProcessing: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: 'videoRef',
    },
    video: {
      type: String,
      required: false,
      default: '',
    },
    preload: {
      type: String,
      required: false,
      default: 'metadata',
    },
    hidePosterOnLargeScreens: {
      type: Boolean,
      required: false,
      default: false,
    },
    posterImage: {
      type: String,
      required: false,
      // default: config.DEFAULT_PROFILE_PIC
    },
    showPlayIcon: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      videoPlaying: false,
      loadingInstance: null,
    }
  },
  mounted() {
    if (this.isVidProcessing) {
      this.invokeLoading()
    } else if (this.loadingInstance) this.loadingInstance.close()
  },
  watch: {
    isVidProcessing(newVal) {
      if (newVal) {
        this.invokeLoading()
      } else if (this.loadingInstance) {
        this.loadingInstance.close()
      }
    },
  },
  computed: {
    imageUrl: function () {
      if (this.posterImage) {
        return this.posterImage
      }
      // if(this.posterImage && this.posterImage instanceof File) {
      //   return this.posterImage
      // }
      if (!this.video) {
        return config.DEFAULT_PROFILE_PIC
      }
    },
  },
  methods: {
    playVideoInThumbnail(id, playNow) {
      const vid = this.$refs[id]

      this.videoPlaying = playNow
      if (playNow) {
        vid.play()
        vid.controls = true
      }
    },
    invokeLoading() {
      this.loadingInstance = Loading.service({
        target: '#loading-node',

        text: this.$t('Processing'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        customClass: 'loader',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
video {
  height: inherit;
}
.thumb-pic-play-icon {
  z-index: 11;
}

.video-with-thumbnail {
  &::v-deep {
    .loader {
      .el-icon-loading {
        color: white;
        font-size: 1.5rem;
      }

      .el-loading-text {
        color: white;
      }
    }
  }
}

.loading-con {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
.thumb-video-box {
  width: 100%;
  height: 100%;
  video {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
}
.hide-on-lg {
  @media screen and (min-width: 768px) {
    display: none;
  }
}
</style>
